import React, { useEffect, useState } from 'react';

import { DocumentsSections } from '@cd3p/core/modules/documents';
import { APILanguage } from '@cd3p/core/types/api';
import i18n from 'i18n';

import { useParams, useSelector, useTranslation } from 'third-party';

import { whatIsNewEditorUrl } from 'constants/url';

import { useReleaseNotes } from 'modules/releaseNotes';

import { releaseNotesSelectors } from 'selectors';

import { DocsEditor } from 'features/Docs/DocsEditor';

const applicationsOptions = [
  {
    label: i18n.t('docs.applications.contractorWeb'),
    value: DocumentsSections.WhatIsNewWebContractor,
  },
  {
    label: i18n.t('docs.applications.providerWeb'),
    value: DocumentsSections.WhatIsNewWebDispatcher,
  },
  {
    label: i18n.t('docs.applications.contractorMobile'),
    value: DocumentsSections.WhatIsNewMobileContractor,
  },
];

const treeProps = {
  rowHeight: 30,
  hasSections: false,
};

export const ReleaseNotesEditor = () => {
  const { t } = useTranslation();
  const [language, setLanguage] = useState<APILanguage>(APILanguage.English);

  const { applicationId, documentId } = useParams();

  const {
    loadReleaseNotesDocuments,
    saveReleaseNotesDocument,
    deleteReleaseNotesDocument,
    fetchReleaseNotesDocument,
    resetReleaseNotesDocuments,
  } = useReleaseNotes(applicationId as DocumentsSections, language);

  const items = useSelector(releaseNotesSelectors.releaseNotesItemsTree);
  const itemsLoading = useSelector(
    releaseNotesSelectors.releaseNotesItemsLoading,
  );
  const itemsLoaded = useSelector(
    releaseNotesSelectors.releaseNotesItemsLoaded,
  );
  const documentLoading = useSelector(
    releaseNotesSelectors.fetchReleaseNotesDocumentPending,
  );

  useEffect(() => {
    return () => {
      resetReleaseNotesDocuments();
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <DocsEditor
      title={t('releaseNotes.title')}
      applicationId={applicationId as DocumentsSections}
      documentId={documentId}
      items={items}
      itemsLoading={itemsLoading}
      itemsLoaded={itemsLoaded}
      documentLoading={documentLoading}
      loadDocuments={loadReleaseNotesDocuments}
      saveDocument={saveReleaseNotesDocument}
      deleteDocument={deleteReleaseNotesDocument}
      fetchDocument={fetchReleaseNotesDocument}
      editorUrl={whatIsNewEditorUrl}
      language={language}
      setLanguage={setLanguage}
      applications={applicationsOptions}
      treeProps={treeProps}
    />
  );
};
